
import { Component, Prop, Vue } from 'vue-property-decorator'
import SidemenuLayout from '@/components/organisms/layout/SidemenuLayout.vue'
import NoticeMessageLinkPanel from '@/components/organisms/NoticeMessageLinkPanel.vue'
import NoticeMessagePanel from '@/components/organisms/NoticeMessagePanel.vue'
import { NoticeMessageData } from '@/models/NoticeMessage'

/**
 * お知らせメッセージ詳細画面のレイアウト
 */
@Component({
  components: {
    SidemenuLayout,
    NoticeMessageLinkPanel,
    NoticeMessagePanel,
  },
})
export default class NoticeMessageList extends Vue {
  /** リンクパネル押下時の遷移先URL */
  @Prop()
  private eventClickLinkButton!: () => void

  /** メッセージ情報 */
  @Prop()
  private message!: NoticeMessageData
}
